export enum LogActionTypes {
  USER_LOGIN = 'user.login',
  USER_LOGOUT = 'user.logout',
  USER_GROUP_SCORES_BY_CHAPTER = 'user.group.scores.by.chapter',
  USER_GROUP_SCORES_BY_TRAJECTORY = 'user.group.scores.by.trajectory',
  USER_GROUP_PROGRESS_BY_CHAPTER = 'user.group.progress.by.chapter',
  USER_PROGRESS_BY_CHAPTER = 'user.progress.by.chapter',
  USER_SCORES_BY_CHAPTER = 'user.scores.by.chapter',
  USER_SEARCH_TASK = 'user.search.task',
  USER_CALCULATOR_SCIENCE = 'user.calculator_science',
  USER_CALCULATOR_MATH = 'user.calculator_math',
  USER_IDLE_TIME = 'user.idletime',
  USER_NAVIGATES_THROUGH_CLICK = 'user.navigates.through.click',

  NAVIGATION_HOMEPAGE = 'navigation.homepage',
  NAVIGATION_BOOKS = 'navigation.books',
  NAVIGATION_BOOKS_TRAJECTORY = 'navigation.books.trajectory',
  NAVIGATION_ENDTERM_OVERVIEW = 'navigation.endtermOverview',

  STUDENT_SCORES_BY_CHAPTER = 'student.scores.by.chapter',
  STUDENT_SCORES_BY_TRAJECTORY = 'student.scores.by.trajectory',
  STUDENT_PROGRESS_BY_CHAPTER = 'student.progress.by.chapter',
  STUDENT_FINISH_ASSIGNMENT = 'student.finish.assignment',
  STUDENT_UNDERSTANDS_SECTION = 'student.understands.section',

  GROUPS_ATTACH = 'groups.attach',
  GROUPS_CREATE = 'groups.create',

  DIFFERENTIATIONS_CREATE = 'differentiations.create',

  ASSIGNMENTS_CREATE = 'assignments.create',

  /* BOOKMARKS */
  STUDENT_CREATE_BOOKMARK = 'student.create.bookmark',
  STUDENT_READ_BOOKMARK_TOC = 'student.read.bookmark.toc',
  STUDENT_READ_TEACHER_BOOKMARK_TOC = 'student.read.teacher.bookmark.toc',
  STUDENT_READ_BOOKMARK_BOOK_PAGE = 'student.read.bookmark.book.page',
  STUDENT_READ_TEACHER_BOOKMARK_BOOK_PAGE = 'student.read.teacher.bookmark.book.page',
  TEACHER_BOOKMARKS_CREATE = 'teacher.bookmarks.create',
  TEACHER_READ_BOOKMARK_BOOK_PAGE = 'teacher.read.bookmark.book.page',
  TEACHER_READ_BOOKMARK_TOC = 'teacher.read.bookmark.toc',
  /* BOOKMARKS */

  ACTIONS_PRINT = 'actions.print',
  ACTIONS_TEACHER_LOBBY = 'actions.teacherLobby',
  ACTIONS_TEACHER_LOBBY_TOC = 'actions.teacherLobbyToc',

  TEACHER_TRAJECTORY_VISIBILITY = 'teacher.trajectory.visibility',
  TEACHER_ENABLE_CHAPTER_VISIBILITY = 'teacher.enable.chapter.visibility',
  TEACHER_DISABLE_CHAPTER_VISIBILITY = 'teacher.disable.chapter.visibility',
  TEACHER_PAGE_CREATE = 'teacher.page.create',
  TEACHER_BLOCK_CREATE = 'teacher.block.create',
  TEACHER_PAGE_DELETE = 'teacher.page.delete',
  TEACHER_BLOCK_DELETE = 'teacher.block.delete',

  FEEDBACK_TEACHER_CREATE = 'feedback.teacher.create',
  FEEDBACK_TEACHER_DELETE = 'feedback.teacher.delete',
  FEEDBACK_TEACHER_READ = 'feedback.teacher.read',
  FEEDBACK_STUDENT_READ = 'feedback.student.read',
  FEEDBACK_STUDENT_SHORTCUT = 'feedback.student.shortcut',

  OPEN_WEBSITE = 'open.website',
  CLOSE_WEBSITE = 'close.website',

  TRAJECTORY_FULLSCREEN_ENABLE = 'trajectory.fullscreen.enable',
  TRAJECTORY_FULLSCREEN_DISABLE = 'trajectory.fullscreen.disable',
  TRAJECTORY_ERROR_LOADING = 'trajectory.error.loading',
  TRAJECTORY_ERROR_MULTIPLE_PAGES = 'trajectory.error.multiple.pages',

  TOURS_RESET = 'tours.reset',
  TOUR_STARTED = 'tour.started',
  TOUR_FINISHED = 'tour.finished',
  TOUR_SKIPPED = 'tour.skipped',
  TOUR_STEP_FORWARD = 'tour.step.forward',
  TOUR_STEP_BACK = 'tour.step.back',

  GRADES_PATCHED = 'User grades changed...',

  HOMEPAGE_TEACHER = 'homepage.teacher',
  HOMEPAGE_TEACHER_SCROLL_BOOKS = 'homepage.teacher.scroll.books',
  HOMEPAGE_TEACHER_GOTO_BOOK = 'homepage.teacher.goto.book',
  HOMEPAGE_TEACHER_GOTO_CONTACT = 'homepage.teacher.goto.contact',
  HOMEPAGE_TEACHER_GOTO_GRADES_MANAGER = 'homepage.teacher.goto.books',
  HOMEPAGE_REDIRECT_TO_STUDENT_DASHBOARD = 'homepage.redirect.to.student.dashboard',
  HOMEPAGE_TOGGLE_BOOKS_LIST = 'homepage.toggle.books.list',

  // #855 - Event logging: New home page
  HOMEPAGE_TO_BOOK_THROUGH_TITLE = 'homepage.book.open.title',
  HOMEPAGE_TO_BOOK_THROUGH_IMAGE = 'homepage.book.open.image',
  HOMEPAGE_TO_BOOK_NEW_TAB = 'homepage.book.open.tab',
  HOMEPAGE_TO_AVAILABLE_BOOK = 'homepage.available',
  HOMEPAGE_TO_PREVIEW_BOOK = 'homepage.preview',
  HOMEPAGE_TO_TRAINING_BOOK = 'homepage.training',
  HOMEPAGE_TO_SELF_SERVICE = 'homepage.service',
  HIDE_CONNECTED_BOOKS = 'homepage.book.hide',
  SHOW_CONNECTED_BOOKS = 'homepage.book.show',

  BOOK_CARD_OPEN = 'book.card.open',

  BOOK_CARD_CAROUSEL_BACK_PAGE = 'book.card.carousel.back.page',
  BOOK_CARD_CAROUSEL_NEXT_PAGE = 'book.card.carousel.next.page',

  ERROR = 'error',

  DASHBOARD_SET_ORDERING = 'dashboard.set.ordering',
  DASHBOARD_SET_ORDERING_NAME = 'dashboard.set.ordering.name',
  DASHBOARD_SET_ORDERING_THEORY = 'dashboard.set.ordering.theory',
  DASHBOARD_SET_ORDERING_EXERCISE = 'dashboard.set.ordering.exercise',
  DASHBOARD_SET_ORDERING_OPBOUW = 'dashboard.set.ordering.opbouw',
  DASHBOARD_SET_GROUPS = 'dashboard.set.groups',
  DASHBOARD_SET_FILTER_GROUP = 'dashboard.set.filter.group',
  DASHBOARD_CLOSE_WELCOME_MESSAGE = 'dashboard.close.welcome.message',
  DASHBOARD_OPEN = 'dashboard.open',
  DASHBOARD_OPEN_SIDEBAR = 'dashboard.open.sidebar',
  DASHBOARD_CLOSE_SIDEBAR = 'dashboard.close.sidebar',
  DASHBOARD_SET_ATTEMP_FILTER = 'dashboard.set.attemp.filter',

  // #685 - Self Service Portal event logging
  SELF_SERVICE_OPEN = 'selfservice.main.open',
  SELF_SERVICE_CLASSES_OPEN = 'selfservice.classes.open',
  SELF_SERVICE_CLASSES_CANCEL = 'selfservice.classes.cancel',
  SELF_SERVICE_CLASSES_ADD = 'selfservice.classes.add',
  SELF_SERVICE_BOOKS_ADD = 'selfservice.books.add',
  SELF_SERVICE_BOOKS_CANCEL = 'selfservice.books.cancel',
  SELF_SERVICE_CLASS_DETAILS_OPEN = 'selfservice.class.open',
  SELF_SERVICE_CLASS_DETAILS_ADD_BOOKS = 'selfservice.class.addbooks',

  // #686 Trajectory name change event logging
  SAVE_TRAJECTORY_NAME = 'trajectory.name.save',
  CANCEL_TRAJECTORY_NAME_CHANGE = 'trajectory.name.cancel',
  START_TRAJECTORY_NAME_CHANGE = 'trajectory.name.change',
  REVERT_TRAJECTORY_NAME_TO_DEFAULT = 'trajectory.name.revert',

  // study trainer log events
  OPEN_TRAINER = 'studycard.open',
  PREVIEW_CARD = 'studycard.preview',
  OPEN_FORM = 'studycard.form.open',
  MAKE_CARDS_UNKNOWN = 'studycard.makecardsunknown',
  START_PRACTICE = 'studycard.startedpracticing',
  SHOW_CARD = 'studycard.shown',
  CARD_CORRECT = 'studycard.correct',
  CARD_TRY_AGAIN = 'studycard.tryagain',
  CARD_KNOWN = 'studycard.known',
  FLIP_CARD = 'studycard.flipped',
  STOP_PRACTICE = 'studycard.endedpracticing',
  STUDYCARD_DELETE_CARD = 'studycard.delete.card',
  STUDYCARD_ADD_CARD = 'studycard.add.card',
  STUDYCARD_EDIT_CARD = 'studycard.edit.card',
  STUDYCARD_REORDER_CARD = 'studycard.reorder.card',
  STUDYCARD_UPLOAD_EXCEL_FILE = 'studycard.upload.excel.file',

  // notes log events
  CREATE_NOTE = 'note.create',
  EDIT_NOTE = 'note.edit',
  DELETE_NOTE = 'note.delete',
  CONFIRM_NOTE_DELETION = 'note.confirmdelete',
  PRINT_NOTES = 'notes.print',
  SHOW_ALL_NOTES = 'notes.show',
  HIDE_ALL_NOTES = 'notes.hide',
  SHOW_NOTE = 'note.show',
  SHOW_BLOCK_FROM_NOTE = 'note.showblock',
  PRINT_STUDENTNOTES = 'teacher.studentnotes.print',
  SHOW_STUDENTNOTES = 'teacher.studentnotes.show',
  SHOW_GROUP_STUDENTNOTES = 'teacher.studentnotes.showgroup',
  HIDE_GROUP_STUDENTNOTES = 'teacher.studentnotes.hidegroup',

  // immersive reader
  IMMERSIVE_READER_ACTIVATE = 'immersivereader.activate',
  IMMERSIVE_READER_DEACTIVATE = 'immersivereader.deactivate',

  // Paper Digital
  PAPER_MANUAL_OPEN = 'manual.open',
  PAPER_MANUAL_CLOSE = 'manual.close',
  PAPER_MANUAL_SEEN = 'manual.seen.cta',

  // Navbar
  NAVBAR_WAS_SEEN = 'navbar.seen',
  NAVBAR_OPEN = 'navbar.open.cta',

  // Ctas for demo
  DOWNLOAD_WAS_SEEN_CTA = 'download.seen.cta',
  DOWNLOAD_OPEN = 'download.open',
  GROUPS_SEEN_CTA = 'groups.seen.cta',
  FOLLOW_UP_SEEN_CTA = 'followUp.seen.cta',
  DIFFERENTIATIONS_SEEN_CTA = 'differentiations.seen.cta',
  ASSIGNMENTS_SEEN_CTA = 'assignments.seen.cta',
  BOOKMARK_SEEN_CTA = 'bookmark.seen.cta',
  TABLE_OF_CONTENTS_SEEN_CTA = 'tableOfContents.seen.cta',
  GRADE_MANAGER_SEEN_CTA = 'gradeManager.seen.cta',
  PRESENTATION_MODE_SEEN_CTA = 'presentation.seen.cta',

  // Print trajectory
  PRINT_TRAJECTORY_REQUEST = 'print.trajectory.request',
  PRINT_TRAJECTORY_SUCCESS = 'print.trajectory.success',
  PRINT_TRAJECTORY_ERROR = 'print.trajectory.error',
  PRINT_BOOK_REDIRECT = 'print.book.redirect',

  // Navigation Bar
  NAVIGATION_BAR_OPEN = 'navigation.bar.open',
  NAVIGATION_BAR_CLOSE = 'navigation.bar.close',
  NAVIGATION_BAR_ROUTE_TOC = 'navigation.bar.route.toc',
  NAVIGATION_BAR_ROUTE_CLUSTER = 'navigation.bar.route.cluster',
  NAVIGATION_BAR_SCROLL_TOP = 'navigation.bar.scroll.top',

  // CONTACT_FORM MENU
  CONTACT_FORM_CLICK = 'contact.form.click',
  CONTACT_FORM_FAQ = 'contact.form.faq',
  CONTACT_FORM_CONTACT = 'contact.form.contact',
  CONTACT_FORM_TRAINNING_VIDEO = 'contact.form.trainning.video',

  // COMUNICATIONS

  // // NOTIFICATIONS
  NOTIFICATIONS_OPEN_SIDEPANEL = 'notifications.open.sidepanel',
  NOTIFICATIONS_LINK_CLICK = 'notifications.link.click',

  // PLATFORM GUIDE VIDEO
  PLATFORM_GUIDE_OPEN = 'platform.guide.open',
  PLATFORM_GUIDE_CLOSED = 'platform.guide.closed',

  //STEPPER
  STEPPER_VIEWED = 'stepper.viewed',
  STEPPER_END = 'stepper.end',
  STEPPER_CLICK_PREVIOUS = 'stepper.click.previous',
  STEPPER_CLICK_NEXT = 'stepper.click.next',
}
